export const sage = {
  sage_configurations: `Configuraciones de SageX3`,
  sagex3_invoicetype_require: "El tipo de factura es obligatorio.",
  sagex3_facility_required: "La instalación es obligatoria.",
  sagex3_invoicedate_required: "La fecha de la factura es obligatoria.",
  sagex3_supplier_required: "El proveedor es obligatorio.",
  sagex3_totalwithouttax_required: "El total sin impuestos es obligatorio.",
  sagex3_totalwithouttax_must_be_greater_than_zero:
    "El total sin impuestos debe ser mayor que cero.",
  sagex3_comment_length_lessthanorequal_30characters:
    "El comentario debe tener 30 caracteres o menos.",
  sagex3_items_required: "Se requiere al menos un artículo.",
  sagex3_items_productcode_required:
    "El código de producto es obligatorio para cada artículo.",
  sagex3_items_quantity_required:
    "La cantidad es obligatoria para cada artículo.",
  sagex3_items_taxcode_required:
    "El código de impuestos es obligatorio para cada artículo.",
  sagex3_items_both_po_dn_not_allwed_same_item:
    "No se pueden usar ambos, la orden de compra y el albarán, para el mismo artículo.",
  sagex3_receiptdate_required: "La fecha de recepción es obligatoria.",
  sagex3_receiptdate_unvalid: "La fecha de recepción no es válida.",
  sagex3_items_poitem_required:
    "El artículo de la orden de compra es obligatorio para cada artículo.",
};
